
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Sinister } from '../../../../shared/types/sinisters/sinisterInfo';
import { SamplingClassification } from '../../../../shared/types/notes/notes';
import {
  DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR,
} from '../colors';
import { UnclassifiedSampling } from '../enrich-notes';
import { calculateClaimPercentDamage } from '../damage/damageCalculations';
import LoadingIndicator from '../../../../core/components/Generics/LoadingIndicator.vue';

@Component({
  components: {
    LoadingIndicator,
  },
})
export default class InspectionSamplingReport extends Vue {
  @Prop({ required: true }) sinister!: Sinister;
  @Prop({ default: () => [] }) classifications!: SamplingClassification[];
  @Prop({ default: () => ({}) }) classificationColors!: Record<number, string>;
  @Prop({ default: () => [] }) unclassifiedSamplings!: UnclassifiedSampling[];
  @Prop({ type: Boolean, default: false }) loading!: boolean;

  unclassifiedColor = DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR;

  get isManualDamage(): boolean {
    return this.sinister.manual_percent_damage != null;
  }

  get totalDamageDisplay(): string {
    const manual = this.sinister.manual_percent_damage;
    const calculated = calculateClaimPercentDamage(this.classifications);
    const value = manual != null ? manual : calculated;
    return value != null ? `${value}%` : '-';
  }

  get hasUnclassified(): boolean {
    return (this.unclassifiedSamplings || []).length > 0;
  }

  get hasListItems(): boolean {
    return this.hasUnclassified || (this.classifications || []).length > 0;
  }

  get classificationsWithColor(): Array<{
    classification: SamplingClassification;
    color: string;
  }> {
    return (this.classifications || []).map(classification => ({
      classification,
      color:
        this.classificationColors[classification.id] ||
        DEFAULT_UNCLASSIFIED_SAMPLING_MARKER_COLOR,
    }));
  }

  formatPercent(value: number | null | undefined): string {
    return value != null ? `${value}%` : '-';
  }

  /** Match mobile: no linked samples → show dash (API may send 0) */
  formatClassificationDamage(classification: SamplingClassification): string {
    const hasSamples =
      classification.samplings && classification.samplings.length > 0;
    if (!hasSamples) {
      return '-';
    }
    return this.formatPercent(classification.calculated_percent_damage);
  }

  formatArea(value: number | null | undefined): string {
    return value != null ? `${Number(value).toFixed(2)} ha` : '-';
  }

  samplingChipLabel(sampling: {
    description?: string;
    percent_damage?: number;
  }): string {
    const raw = sampling.description;
    const description =
      raw != null && String(raw).trim() !== '' ? String(raw).trim() : '-';
    const damage =
      sampling.percent_damage != null ? String(sampling.percent_damage) : '-';
    return `${description} | ${damage}`;
  }
}
